import {Controller, useFormContext} from "react-hook-form";
import {Input, Space} from "antd";
import {CreateUserScheduleFormValues} from "../../schema-validation";
import {
  FormField,
  FormFieldError,
} from "../../../../../../../../../design-system/form-field";

export function UserScheduleNameFormField() {
  const {control} = useFormContext<CreateUserScheduleFormValues>();

  return (
    <FormField
      id="scheduleName"
      label="Schedule name"
      renderInput={(id) => (
        <Controller
          control={control}
          name="scheduleName"
          render={({field: {onChange, value, ref, onBlur}, fieldState: {error}}) => (
            <Space size={8} direction="vertical" style={{display: "flex"}}>
              <Space size={4} direction="vertical" style={{display: "flex"}}>
                <Input
                  id={id}
                  status={error?.message ? "error" : ""}
                  onChange={onChange}
                  onBlur={onBlur}
                  size="large"
                  value={value === null ? undefined : value}
                  placeholder="e.g weekend sessions, business hours"
                  ref={ref}
                />
              </Space>
              <FormFieldError errorMessage={error?.message} />
            </Space>
          )}
        />
      )}
    />
  );
}
